export function calcDistance(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // 地球半径
    const φ1 = (lat1 * Math.PI) / 180; // 第一个点的纬度转化为弧度
    const φ2 = (lat2 * Math.PI) / 180; // 第二个点的纬度转化为弧度
    const Δφ = ((lat2 - lat1) * Math.PI) / 180; // 两点纬度之差转化为弧度
    const Δλ = ((lon2 - lon1) * Math.PI) / 180; // 两点经度之差转化为弧度
    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  
    const distance = R * c; // 距离，单位为米
  
    return Math.floor(distance);
  }


// WEBPACK FOOTER //
// ./src/utils/index.js